const logInToBroadSoft = ({ userId, password, url }) => {
  const body = document.querySelector('body');
  const form = document.createElement('form');
  const userIdInput = document.createElement('input');
  const passwordInput = document.createElement('input');

  form.setAttribute('action', url);
  form.setAttribute('method', 'post');
  form.setAttribute('target', '_blank');

  userIdInput.setAttribute('type', 'hidden');
  userIdInput.setAttribute('name', 'UserID');
  userIdInput.setAttribute('value', userId);

  passwordInput.setAttribute('type', 'hidden');
  passwordInput.setAttribute('name', 'Password');
  passwordInput.setAttribute('value', password);

  form.appendChild(userIdInput);
  form.appendChild(passwordInput);

  body.appendChild(form);

  form.submit();

  body.removeChild(form);
};

export { logInToBroadSoft };
